export const PageData = {
    introduction: [
    {
        heading: "Introduction",
        id: 1,
        text: [
            {
                id: 1,
                subtitle: "Opening: ",
                body: "If you're a U.S. citizen planning to marry a foreign fiancé, the K-1 Fiancé Visa can help bring them to the United States so you can start your life together. The K-1 Visa allows your fiancé to enter the U.S. for a period of 90 days, during which you must get married to proceed with their permanent residency application.",
            },
            {
                id: 2,
                subtitle: "Goal: ",
                body: "This guide will walk you through the entire K-1 Visa process, eligibility requirements, and necessary documentation to help you bring your fiancé to the U.S. smoothly. GIT Global is here to support you every step of the way.",
            },
        ]
    },
    ],
    whatIsK1Fiance: [
        {
            heading: "What is the K-1 Fiancé Visa?",
            id: 1,
            text: [
                {
                    id: 1,
                    opening: "The",
                    bold: "K-1 Fiancé Visa",
                    normal: "is a non-immigrant visa for the fiancé of a U.S. citizen. It allows the foreign fiancé to enter the U.S. to marry their partner within 90 days. After the marriage, the foreign spouse can apply for a Green Card (permanent residency) to stay in the United States permanently.",
                },
            ] 
        },
    ],
    eligibilityRequirements: [
        {
            heading: "Eligibility Requirements for the K-1 Fiancé Visa",
            subheading: "To qualify for a K-1 Visa, certain requirements must be met:",
            id: 1,
            requirements: [
                {
                    id: 1,
                    bold: "U.S. Citizenship of the Petitioner: ",
                    normal: "The petitioner must be a U.S. citizen to apply for a K-1 Visa on behalf of their foreign fiancé.",
                },
                {
                    id: 2,
                    bold: "Intention to Marry: ",
                    normal: "Both the petitioner and the fiancé must intend to marry within 90 days of the fiancé’s arrival in the U.S.",
                },
                {
                    id: 3,
                    bold: "In-Person Meeting Requirement: ",
                    normal: "The couple must have met in person at least once within the last two years before applying for the K-1 Visa. Exceptions can be made if meeting in person would cause extreme hardship or violate cultural or religious practices.",
                },
                {
                    id: 4,
                    bold: "Both Parties Are Legally Able to Marry: ",
                    normal: "Both the petitioner and the fiancé must be legally free to marry, meaning any previous marriages must be legally terminated by divorce, annulment, or death.",
                },
            ] 
        },
    ],
    guideToK1Visa: [
        {
            heading: "Step-by-Step Guide to the K-1 Fiancé Visa Process",
            id: 1,
            steps: [
                {
                    id: 1,
                    heading: "File Form I-129F, Petition for Alien Fiancé",
                    body: "The first step is for the U.S. citizen petitioner to submit Form I-129F to U.S. Citizenship and Immigration Services (USCIS). This form establishes the relationship and intention to marry.",
                    requiredDocuments: [
                        {
                            heading: "Supporting Documents for Form I-129F:",
                            id: 1,
                            documents: [
                                {
                                    id: 1,
                                    info: "Evidence of U.S. citizenship (e.g., passport, birth certificate).",
                                },
                                {
                                    id: 2,
                                    info: "Proof of relationship, such as photos, travel records, or communication history.",
                                },
                                {
                                    id: 3,
                                    info: "Statement of intent to marry within 90 days.",
                                },
                                {
                                    id: 4,
                                    info: "Passport-style photos for both the petitioner and fiancé.",
                                },
                            ],
                        },
                    ], 
                    tips: [
                        {
                            heading: "Tip: ",
                            id: 1,
                            body: "Ensure all forms and documents are complete and accurate, as missing or incorrect information can delay the process.",
                        },
                    ],
                },
                {
                    id: 2,
                    heading: "Approval and Forwarding to the National Visa Center (NVC)",
                    body: "Once Form I-129F is approved, USCIS will forward the case to the National Visa Center (NVC). The NVC will assign a case number and send the application to the U.S. embassy or consulate in your fiancé’s home country.",
                    requiredDocuments: [], 
                    tips: [],
                },
                {
                    id: 3,
                    heading: "Apply for the K-1 Visa at the U.S. Embassy or Consulate",
                    body: "The foreign fiancé must apply for the K-1 Visa by completing the DS-160 Online Nonimmigrant Visa Application and scheduling an interview at the U.S. embassy or consulate.",
                    requiredDocuments: [
                        {
                            heading: "Required Documents for the Embassy Interview:",
                            id: 1,
                            documents: [
                                {
                                    id: 1,
                                    info: "Completed Form DS-160 and confirmation page.",
                                },
                                {
                                    id: 2,
                                    info: "Valid passport.",
                                },
                                {
                                    id: 3,
                                    info: "Medical examination report from an authorized physician.",
                                },
                                {
                                    id: 4,
                                    info: "Proof of relationship, including photos and communication records.",
                                },
                                {
                                    id: 5,
                                    info: "Police certificates from any country where the fiancé has lived for six months or more.",
                                },
                                {
                                    id: 6,
                                    info: "Evidence of financial support, like Form I-134, Affidavit of Support.",
                                },
                            ],
                        },
                    ], 
                    tips: [
                        {
                            heading: "Tips for the Interview: ",
                            id: 1,
                            body: "The consular officer will ask questions about the relationship to verify its legitimacy. Being prepared with clear answers and all required documentation will improve the chances of approval.",
                        },
                    ],
                },
                {
                    id: 4,
                    heading: "Receive the K-1 Visa and Travel to the U.S.",
                    body: "",
                    requiredDocuments: [
                        {
                            heading: "",
                            id: 1,
                            documents: [
                                {
                                    id: 1,
                                    info: "If approved, the fiancé will receive the K-1 Visa, which is valid for entry into the U.S. for 90 days.",
                                },
                                {
                                    id: 2,
                                    info: "Once in the U.S., the couple must get married within this 90-day period.",
                                },
                            ],
                        },
                    ], 
                    tips: [],
                },
                {
                    id: 5,
                    heading: "Receive the K-1 Visa and Travel to the U.S.",
                    body: "",
                    requiredDocuments: [
                        {
                            heading: "",
                            id: 1,
                            documents: [
                                {
                                    id: 1,
                                    info: "After the marriage, the foreign spouse can apply for a Green Card through the Adjustment of Status process. This requires filing Form I-485, Application to Register Permanent Residence or Adjust Status.",
                                },
                                {
                                    id: 2,
                                    info: "Upon approval, the foreign spouse will become a permanent resident and receive a Green Card.",
                                },
                            ],
                        },
                    ], 
                    tips: [],
                },
            ],
        },
    ],
    commonChallenges: [
        {
            heading: "Common Challenges in the K-1 Visa Process",
            subheading: "",
            id: 1,
            text: [
                {
                    id: 1,
                    subtitle: "Delays in Processing: ",
                    body: "Processing times for the K-1 Visa can vary, and applicants should be prepared for potential delays.",
                },
                {
                    id: 2,
                    subtitle: "Document and Evidence Requirements: ",
                    body: "Missing or insufficient evidence can lead to delays or even denials.",
                },
                {
                    id: 3,
                    subtitle: "Visa Interview Questions: ",
                    body: "Some applicants may feel nervous or unprepared for the interview, which is essential to proving the legitimacy of the relationship.",
                },
            ]
        },
        {
            heading: "How GIT Global Can Help with Your K-1 Fiancé Visa Application",
            subheading: "Navigating the K-1 Visa process can be complex, but GIT Global is here to assist you every step of the way:",
            id: 2,
            text: [
                {
                    id: 1,
                    subtitle: "Document Preparation and Review: ",
                    body: "GIT Global will guide you in gathering all necessary documents, ensuring everything is complete and accurate to avoid delays.",
                },
                {
                    id: 2,
                    subtitle: "Interview Preparation: ",
                    body: "Our team provides one-on-one interview coaching to help you and your fiancé feel confident and prepared for the embassy interview.",
                },
                {
                    id: 3,
                    subtitle: "Support for Adjustment of Status: ",
                    body: "After your marriage, GIT Global can assist with the Adjustment of Status process, ensuring a smooth transition to permanent residency.",
                },
            ]
        },
    ],
    potentialChanges: [
        {
            heading: "Potential Changes to Immigration Under Trump",
            id: 1,
            procedures: [
                {
                    title: "Tighter Border Security and Enforcement",
                    id: 1,
                    steps: [
                        {
                            id: 1,
                            subtitle: "What to Expect: ",
                            body: "Trump has previously emphasized stricter border security, so we may see renewed focus on border wall construction, increased funding for border patrol, and policies aimed at deterring unauthorized immigration.",
                        },
                        {
                            id: 2,
                            subtitle: "Impact: ",
                            body: "This focus could lead to longer wait times and enhanced scrutiny at points of entry, impacting certain visa applications and travel.",
                        },
                    ],
                },
                {
                    title: "Changes to Family-Based Immigration",
                    id: 2,
                    steps: [
                        {
                            id: 1,
                            subtitle: "What to Expect: ",
                            body: "Family-based immigration policies could come under more scrutiny, with potential efforts to restrict family reunification and limit the number of visas granted to extended family members.",
                        },
                        {
                            id: 2,
                            subtitle: "Impact: ",
                            body: "Applicants for family-based visas may experience increased processing times and may need to provide additional evidence to demonstrate the legitimacy of family relationships.",
                        },
                    ],
                },
                {
                    title: "Revised Rules for Refugee and Asylum Programs",
                    id: 3,
                    steps: [
                        {
                            id: 1,
                            subtitle: "What to Expect: ",
                            body: "During his previous administration, Trump implemented restrictions on refugee admissions and imposed limits on asylum applications. A renewed focus on asylum and refugee vetting procedures could impact the number of refugees admitted each year.",
                        },
                        {
                            id: 2,
                            subtitle: "Impact: ",
                            body: "Individuals seeking asylum or refugee status may face longer processing times and stricter requirements for demonstrating eligibility.",
                        },
                    ],
                },
                {
                    title: "Possible Revisions to the DACA Program",
                    id: 4,
                    steps: [
                        {
                            id: 1,
                            subtitle: "What to Expect: ",
                            body: "The Deferred Action for Childhood Arrivals (DACA) program has been a highly debated policy, with previous efforts to rescind it under Trump. A renewed effort to end or alter DACA could impact the legal status of hundreds of thousands of Dreamers.",
                        },
                        {
                            id: 2,
                            subtitle: "Impact: ",
                            body: "This could create uncertainties for Dreamers currently protected under DACA, potentially impacting their work permits and ability to remain in the U.S.",
                        },
                    ],
                },
                {
                    title: "Changes to Employment-Based Immigration",
                    id: 5,
                    steps: [
                        {
                            id: 1,
                            subtitle: "What to Expect: ",
                            body: "Employment-based visas, such as H-1B and L-1, may also be reviewed. Previous policies aimed to prioritize American workers and reduce dependency on foreign labor, and similar initiatives could be proposed again.",
                        },
                        {
                            id: 2,
                            subtitle: "Impact: ",
                            body: "Employers may face stricter hiring requirements, while applicants could encounter additional challenges in obtaining or renewing employment-based visas.",
                        },
                    ],
                },
            ]
        },
    ],
    afterApplication: [
        {
            heading: "How GIT Global Can Help You Prepare",
            subheading: "Navigating potential immigration changes can be challenging, especially with the possibility of new policies and regulations. Here’s how GIT Global can assist you:",
            id: 1,
            text: [
                {
                    id: 1,
                    subtitle: "Up-to-Date Guidance: ",
                    body: "Our team stays informed about the latest immigration policies, ensuring you have accurate information on how any changes might impact your case.",
                },
                {
                    id: 2,
                    subtitle: "Document Preparation and Review: ",
                    body: "GIT Global helps ensure that all necessary documents are submitted correctly, reducing the chance of delays or rejections.",
                },
                {
                    id: 3,
                    subtitle: "Support in Uncertain Times: ",
                    body: "With potential policy shifts on the horizon, GIT Global is here to provide clarity and support for immigrants and their families seeking stability in the U.S.",
                },
            ]
        },
    ],
    
}
